import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import css from "./PricePacksComponent.module.css";
import {packsActions} from "../../../store/slices/settings-slices";
import {PricePackSingleComponent} from "../PricePackSingleComponent/PricePackSingleComponent";


const PricePacksComponent = ({isShow}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {packs, trigger} = useSelector(store => store.packs);

    useEffect(() => {
        dispatch(packsActions.getAllPacks());
    }, [trigger]);


    return (
        <div className={css.wrap}>
            <div className={css.header}>
                <div className={css.headerPack}>{t('settings-menu-title-packs')}</div>
                <div className={css.headerPrice}>{t('modal-price')}</div>
            </div>

            {packs && packs.map((obj) => <PricePackSingleComponent key={obj.id} pack={obj} />)}
        </div>
    );
};

export default React.memo(PricePacksComponent);